export type CurrentResult =
  | 'CaseUpdateFailed'
  | 'CommunicationError'
  | 'ErrorSavingData'
  | 'Failed'
  | 'Pass'
  | 'ProcessingError'
  | 'ScannerError'
  | 'SpecifiedEntryNotFound';

export enum InputProvider {
  NONE = 'NONE',
  CAMERA = 'CAMERA',
  FILESYSTEM = 'FILESYSTEM',
  SCANNER = 'SCANNER',
  LIVENESS = 'LIVENESS',
  SMART_CAPTURE = 'SMART_CAPTURE'
}

export interface JourneyResultProp {
  journeyResult?: JourneyResult;
}

export interface JourneyResult {
  currentResult: CurrentResult;
  highLevelResult?: string;
}

export interface TitleProp {
  title: JSX.Element;
}
